export default __webpack_public_path__ + "static/media/calendar_3.965e513e.svg";